import store from '@/store';
import { reservationRepository } from '@/service/repository/reservationRepository';
import { walkingService } from '@/service/walkingService';

export class HarvisService {
	constructor() {
		this.executionContext = null;
		this.lastWalkinSucceeded = false;
	}

	async call(instruction) {
		this.executionContext = instruction;
		if (this.executionContext) {
			switch (this.executionContext.action) {
				case 'walking':
					console.log('Walking desde harvis: ', this.executionContext);
					return await this.createWalkin();
				case 'activa':
					console.log('Se llama a activar desde harvis');
					return await this.activateTable();
				case 'finaliza':
					console.log('Se llama a desactivar desde harvis');
					return await this.finalizeTable();
				default:
					return 'Todavía no puedo hacer eso, o quizá no te haya entendido bien';
			}
		} else {
			return 'Lo siento, no te he entendido bien';
		}
	}

	async createWalkin() {
		this.lastWalkinSucceeded = false;
		if (this.executionContext.name && this.executionContext.pax) {
			let data = {
				name: this.executionContext.name,
				pax: this.executionContext.pax,
				roomId: null,
			};
			await store.dispatch('copilot/showToastSuccess', {
				message: `Creando Walking para ${this.executionContext.name} de ${this.executionContext.pax}`,
			});
			let createWalkInResult = await walkingService.create(data, { openCommanderOnSuccess: true });

			if (createWalkInResult.result === 0) {
				this.lastWalkinSucceeded = true;
				const tableName = createWalkInResult.reservation?.tables?.[0]?.name ?? 'asignada';
				return `Se ha creado el walkin correctamente y se le ha asignado la mesa ${tableName}`;
			}
			return `No se ha podido asignar mesa.`;
		} else {
			return 'No se ha podido crear el walking por que falta el nombre del comensal o el número de comensales.';
		}
	}

	async activateTable() {
		if (this.executionContext.table) {
			console.log(typeof this.executionContext.table);
			const reservations = store.getters['copilot/reservations'];
			console.log('Reservations desde harvis: ', reservations);
			const reservation = reservations.find(
				(reservation) => Number(reservation.table) === this.executionContext.table && reservation.status < 0,
			);
			if (reservation) {
				await store.dispatch('copilot/showToastSuccess', {
					message: `Activando la mesa ${this.executionContext.table}`,
				});
				const activateResult = await reservationRepository.reactivateReservation(reservation.id);
				return activateResult.result === 0
					? `Se ha ha activado correctamente la mesa ${this.executionContext.table}`
					: `Error activando la mesa.`;
			} else {
				return `La mesa ${this.executionContext.table} no pertenece a ninguna reserva.`;
			}
		} else {
			return 'No se ha proporcionado ninguna mesa';
		}
	}

	async finalizeTable() {
		if (this.executionContext.table) {
			console.log(typeof this.executionContext.table);
			const reservations = store.getters['copilot/reservations'];
			console.log('Reservations desde harvis: ', reservations);
			const reservation = reservations.find(
				(reservation) => Number(reservation.table) === this.executionContext.table && reservation.status === 1,
			);
			if (reservation) {
				await store.dispatch('copilot/showToastSuccess', {
					message: `Finalizando la mesa ${this.executionContext.table}`,
				});
				const finishResult = await reservationRepository.setPaymentPending(reservation.id, 'Otro');
				return finishResult.result === 0
					? `Se ha ha desactivado correctamente la mesa ${this.executionContext.table}`
					: `Error desactivando la mesa.`;
			} else {
				return `La mesa ${this.executionContext.table} no pertenece a ninguna reserva.`;
			}
		} else {
			return 'No se ha proporcionado ninguna mesa';
		}
	}
}

export const harvisService = new HarvisService();
